import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 62.5vw;
    margin-top: 2.8vh;
    margin-left: 1.2vw;
    margin-right: 0.7vw;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const StageBarDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.8vh;
    margin-left: 4vw;
    margin-right: 0.1vw;

    .active{
        background-color: #0090D3;
    }
`

export const StageBarItemDiv = styled.div`
    max-width: 20vw;

    .first {
        text-align: start;
        right: 1vw;
    }

    .last {
        text-align: end;
        right: 2.3vw;
    }

    .lastCircle {
        justify-content: start;
    }
`

export const StageBarDesignDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    .active {
        background-color: #0090D3;
    }
`

export const StageBarCircle = styled.div`
    width: 1vw;
    height: 1vw;
    border-radius: 2vw;
    background-color: #C4C4C4;
`

export const StageBarLine = styled.div`
    width: 6vw;
    height: 0.6vh;
    background-color: #C4C4C4;
`

export const StageBarText = styled.p`
    position: relative;
    right: 2vw;
    font-family: 'Inter', sans-serif;
    text-align: center;
    font-size: 0.95vw;
    line-height: 19px;
    margin-top: 1.2vh;
    margin-bottom: 0;
    width: 5vw;
    max-height: 1vh;
    white-space: pre-line;
`

export const ButtonsDiv = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    margin-left: 34vw;
    margin-top: 5vh;

    a {
        text-decoration: none;
    }

    .xmlButton{
        width: 6vw;
    }

    .xmlImg{
        margin-left: 1.3vw;
    }

    .xmlText{
        margin-left: 0.5vw;
    }

    .nfButton{
        width: 9vw;
    }

    .nfImg{
        margin-left: 1.1vw;
    }

    .nfText{
        margin-left: 0.7vw;
    }

    .certImg{
        margin-left: 1.3vw;
    }

    .certText{
        margin-left: 0.65vw;
    }
`

export const ButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 10vw;
    height: 5.8vh;
    background-color: #fff;
    color: #0090D3;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border: 2px #0090D3 solid;
    border-radius: 3vw;
    cursor: pointer;
    // pointer-events: none;
`

export const ButtonImage = styled.img` 
    width: 0.9vw;
`

export const ButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
`

export const DisabledButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 10vw;
    height: 5.8vh;
    background-color: #ebebeb;
    color: #c4c4c4;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: not-allowed;
`

export const DisabledButtonImage = styled.img` 
    width: 0.9vw;
`

export const DisabledButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
`

export const LoadingMessage = styled.p`
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: #fff;

  img {
    width: 50px;
    margin-top: 9vh;
    margin-bottom: 4vh;
  }
`
